<template>
  <div class="card mt-3">
    <div class="card-body">
      <h5 class="card-title">
        {{ trans("admin.cdr.deletionExecution") }}
      </h5>

      <div v-if="execution.scope && execution.scope.is_notable" class="mb-3">
        {{ execution.scope.label }}
      </div>

      <div v-if="execution.sub_examination_impact" class="mb-3">
        <button
          type="button"
          class="btn btn-link p-0 text-muted small text-decoration-none"
          :aria-expanded="showImpact"
          @click="showImpact = !showImpact"
        >
          <i
            :class="showImpact ? 'fal fa-chevron-down' : 'fal fa-chevron-right'"
          />
          {{ execution.sub_examination_impact.title }}
        </button>
        <div v-if="showImpact" class="card p-3 mt-2">
          <CdrSubExaminationImpactContent
            :impact="execution.sub_examination_impact"
          />
        </div>
      </div>

      <CdrIntegrationAcknowledgements
        :transfers="execution.integration_transfers || []"
        readonly
      />

      <div class="form-check mb-3">
        <input
          id="delete-acknowledge"
          class="form-check-input"
          type="checkbox"
          checked
          disabled
        />
        <label class="form-check-label" for="delete-acknowledge">
          {{ trans("admin.cdr.deletionAcknowledge") }}
        </label>
      </div>

      <div class="row">
        <div class="col-md-6">
          <strong>{{ trans("admin.cdr.executedBy") }}:</strong>
          {{ execution.executed_by_name }}
        </div>
        <div class="col-md-6">
          <strong>{{ trans("admin.cdr.executedAt") }}:</strong>
          {{ execution.executed_at_formatted }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CdrIntegrationAcknowledgements from "./CdrIntegrationAcknowledgements.vue";
import CdrSubExaminationImpactContent from "./CdrSubExaminationImpactContent.vue";

export default {
  components: {
    CdrIntegrationAcknowledgements,
    CdrSubExaminationImpactContent,
  },
  props: {
    execution: { type: Object, required: true },
  },
  data() {
    return {
      showImpact: false,
    };
  },
};
</script>
